import React from 'react';
import styled from 'styled-components';
import BorderTrail from '../BorderTrail';

/**
 * PageBorderTrail
 *
 * A persistent, full-viewport animated border that sits on top of all content.
 * - `position: fixed` keeps it pinned to the viewport edges during scroll.
 * - `pointer-events: none` ensures it never blocks clicks or interactions.
 * - `z-index: 9999` places it above all other content (but below modals at 10000+).
 * - Reads `theme.primary` for the trail colour via styled-components ThemeProvider.
 */

const FixedFrame = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;
  border-radius: 0;
`;

const StyledBorderTrail = styled(BorderTrail).attrs(({ theme }) => ({
  color: theme.primary || '#854CE6',
}))``;

const PageBorderTrail = () => {
  return (
    <FixedFrame>
      <StyledBorderTrail duration={6} borderWidth="2px" />
    </FixedFrame>
  );
};

export default PageBorderTrail;
